export const hireSuggestions: string[] = [
  "Software engineers with 5+ years experience in AI",
  "Product managers who worked at FAANG companies",
  "Data scientists with PhD in Machine Learning",
  "Senior designers with fintech experience",
];

export const leadSuggestions: string[] = [
  "Companies using React in their tech stack",
  "Startups that raised Series A in last 6 months",
  "SaaS companies in healthcare sector",
  "E-commerce businesses with 50+ employees",
];

export const investorSuggestions: string[] = [
  "Angel investors interested in AI startups",
  "VCs focusing on climate tech investments",
  "Partners at top-tier VC firms",
  "Seed investors in B2B SaaS",
];

export const founderSuggestions: string[] = [
  "Technical founders who sold their startup",
  "First-time founders in blockchain",
  "Serial entrepreneurs in Silicon Valley",
  "Female founders in biotech",
];

export const pills = [
  { text: "Find Investors", emoji: "💰", suggestions: investorSuggestions, keyword: "Investors" },
  { text: "Find Founders", emoji: "🚀", suggestions: founderSuggestions, keyword: "Founders" },
  { text: "Find Hires", emoji: "👥", suggestions: hireSuggestions, keyword: "Hires" },
  { text: "Find Leads", emoji: "🎯", suggestions: leadSuggestions, keyword: "Leads" },
];
